// extracted by mini-css-extract-plugin
export default {"anime-list":"AnimeList_anime-list__CEG+H","pagination":"AnimeList_pagination__xpCmU","hidden":"AnimeList_hidden__0Zd-D"};